import { id } from 'date-fns/locale';
import { FormikValues } from 'formik';
import React, { FC, useState } from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';

import { ettersendingSporsmal } from './ettersending-utils';

import './editable-epost.scss';

interface EditableEpostProps {
    formikValues: FormikValues;
}

const EditableEpost: FC<EditableEpostProps> = ({ formikValues }) => {
    const { values, errors, handleBlur, touched, handleChange } = formikValues;
    const [editEpost, setEditEpost] = useState<boolean>(!values.epost);

    return (
        <div className="editable-epost__input-wrapper">
            {editEpost ? (
                <Input
                    name="epost"
                    label={ettersendingSporsmal.epost}
                    type="email"
                    error={touched.epost ? (errors.epost as string) : undefined}
                    value={values.epost}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    autoComplete="email"
                    id={`${id}__epostadresse-input`}
                />
            ) : (
                <>
                    <label htmlFor={`${id}__epostadresse-button`} className="editable-epost__button-label">
                        {ettersendingSporsmal.epost}
                    </label>
                    <LinkButton
                        name="epost"
                        icon={IconTypes.PENN_24}
                        iconOnRightSide
                        onClick={() => setEditEpost(true)}
                        id={`${id}__epostadresse-button`}
                    >
                        {values.epost}
                    </LinkButton>
                </>
            )}
        </div>
    );
};

export default EditableEpost;
